import type { PropsWithChildren, FunctionComponent } from 'react'
import { useState } from 'react'
import { Redirect } from 'react-router'
import { TDS_DEFAULT_COLORS } from '@retailer-platform/shared-components/src/tds'
import { URL_LOGOUT } from '../../../utils/routing/routes'
import { url } from '../../../utils/parsing/url'
import SelectPartner from '../../../gin-and-tonic/common/select-partner/SelectPartner'

const ScopeSelectionPage: FunctionComponent<PropsWithChildren<unknown>> = () => {
  const [modalOpen, setModal] = useState(true)
  const closeModal = () => setModal(false)

  if (!modalOpen) {
    return <Redirect to={url(URL_LOGOUT)} />
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: TDS_DEFAULT_COLORS.colors.brandPrimaryDark,
        }}
      />
      <SelectPartner autoSelect initialLoad handleClose={closeModal} hideOverlay />
    </>
  )
}

export default ScopeSelectionPage
